const whatIfEn = {
	whatIfGroupTable: 'What if group',
	whatIfGroupEditForm: 'What if group',
	whatIfTable: 'What if',
	whatIfExpertTable: 'What if',
	whatIfEditForm: 'What if',
	name: 'Name',
	created: 'Created',
	updated: 'Updated',
	back: 'Back',
	save: 'Save',
	cancel: 'Cancel',
	properties: 'Properties',
	circleProperties: 'Circle Properties',
	deviceProperties: 'Device Properties',
	labelProperties: 'Label Properties',
	rectProperties: 'Rectangle Properties',
	whatIfName: 'Name of What If',
	saveSuccessful: 'Save Successful',
	saveFailed: 'Save failed, all fields is required or name is already in use',
	move: 'Move',
	resize: 'Resize',
	rotate: 'Rotate',
	mirror: 'Mirror',
	devices: 'Devices',
	line: 'Line',
	delete: 'Delete',
	label: 'Label',
	pump: 'Pump',
	compressor: 'Compressor',
	airCooler: 'Air Cooler',
	furnace: 'Furnace',
	heatExchanger: 'Heat Exchanger',
	distillationColumn: 'Distillation Column',
	circle: 'Circle',
	fillColorLabel: 'Fill Color',
	fillLabel: 'Fill',
	borderColorLabel: 'Border Color',
	backgroundColorLabel: 'Background Color',
	fontColorLabel: 'Font Color',
	color_black: 'Black',
	color_white: 'White',
	color_darkRed: 'Red',
	color_darkGreen: 'Green',
	color_darkBlue: 'Blue',
	fontSize: 'Font Size',
	value: 'Value',
	justALabel: 'Just a label',
	imageProperties: 'Image properties',
	imageKey: 'Image',
	image: 'Image',
	none: 'None',
	'group.name': 'Group',
	group: 'User group',
	decimalPlaces: 'Decimal places',
	thousandsSeparator: 'Thousands separator',
	displayAsPercentage: 'Display as percentage',
	workflow: 'Workflow',
	valueKey: 'Value key',
	type: 'Type',
	variable: 'Variable value',
	dict: 'Dict value',
	showUnit: 'Show unit',
	sumTable: 'Summary table',
	sumTableProperties: 'Summary table properties',
	minMax: 'Min/Max',
	documentProperties: 'Documents properties',
	revision: 'Revision',
	'creator.name': 'Uploader',
	file: 'File',
	close: 'Close',
	visible: 'Visible',
	document: 'Document',
	note: 'Note',
	noteProperties: 'Note Properties',
	noteNoContent: 'No content',
	noteUnknownCreator: 'Unknown user',
	notesLoading: 'Loading notes...',
	notesLoadFailed: 'Notes could not be loaded.',
	notesEmpty: 'No notes yet.',
	notesSaveWhatIfFirst: 'Save the What If before adding notes.',
	noteCommentLabel: 'Your comment',
	noteCommentPlaceholder: 'Write your comment here',
	noteSaveFailed: 'The note could not be saved.',
	sendNote: 'Send note',
	retry: 'Retry',
	state: 'State',
	values: 'Values',
	reader: 'Reader',
	'aspect.name': 'Aspect',
	'transformer.name': 'Transformer',
	transformer: 'Transformer',
	aspect: 'Aspect',
	icon: 'Icon',
	iconSize: 'Icon size',
	showLabel: 'Show label',
	input: 'Input',
	output: 'Output',
	tableInDialog: 'Table in a dialog',
	container: 'Container',
	containerProperties: 'Container properties',
	figureNameNotUnique: 'Container name not unique',
	linkTo: 'Link to another What if',
	linkToDialog1: 'Most átleszel irányítva a következő What if-re:',
	linkToDialog2: 'A mentetlen adatok elvesznek. Folytatja?',
	linkToError: 'Hivatkozott What If hiányzik vagy törölve lett.',
	measurement: 'Measurement',
	piMeasurementReader: 'PI Measurement Reader',
	labMeasurementReader: 'Lab Measurement Reader',
	piAfEventReader: 'PI AF Event Reader',
	diffEpsilonValue: 'Difference epsilon value',
	diffEpsilonPercent: 'Difference epsilon percentage',
	o_clipboard: 'Copy to Clipboard',
	to_clipboard_short: 'Copy',
	to_clipboard_successful: 'Data copied to clipboard',
	to_clipboard_failed: 'Error copying to clipboard',
	from_clipboard: 'Paste from Clipboard',
	from_clipboard_short: 'Paste',
	from_clipboard_successful: 'Data successfully pasted from clipboard',
	from_clipboard_failed: 'Paste from clipboard failed, please check the data'
};

export default whatIfEn;
